import { create } from 'zustand';
import { createSessionToken } from '@ev-tech/search-modules-api';

type SessionTokenState = {
  sessionToken: string;
};

type SessionTokenActions = {
  refreshSessionToken: () => void;
};

export const useSessionToken = create<SessionTokenState & SessionTokenActions>((set) => ({
  sessionToken: createSessionToken(),
  refreshSessionToken: () => set({ sessionToken: createSessionToken() }),
}));
